// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
// import { connectAuthEmulator } from "firebase/auth"; // eslint-disable-next-line no-unused-vars
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// const firebaseConfig = {
//   apiKey: "AIzaSyBNAFM0QqgmdqFcYUTTKPYPpvXKGUAKAVM",
//   authDomain: "airsmart-2695a.firebaseapp.com",
//   projectId: "airsmart-2695a",
//   storageBucket: "airsmart-2695a.firebasestorage.app",
//   messagingSenderId: "438636042629",
//   appId: "1:438636042629:web:4d9f85a01702b29cf60cec",
//   measurementId: "G-75K5XY0792",
// };
const firebaseConfig = {
  apiKey: "AIzaSyB2ajltfSn7sYlB4F2RIj2VH6tUR7rQbZ8",
  authDomain: "customshine-7850e.firebaseapp.com",
  projectId: "customshine-7850e",
  storageBucket: "customshine-7850e.firebasestorage.app",
  messagingSenderId: "754679643876",
  appId: "1:754679643876:web:02c461b4e217063d7a76f1",
  measurementId: "G-NFPY2B1GH2"
};

// Initialize Firebase

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
export { auth, analytics, app, db };
